// extracted by mini-css-extract-plugin
export default {"current-time":"current-timer_current-time__Jcv73"};